import { Map } from 'immutable';
import { createSelector } from 'reselect';

const selectNetworkObject = (state) => state.getIn(['me', 'networkSignup', 'network'], Map());

const makeSelectNetworkNetwork = () =>
  createSelector(selectNetworkObject, (state) => state.getIn(['network']));

const makeSelectNetwork = () =>
  createSelector(selectNetworkObject, (state) => state.getIn(['data'], false));

const selectSignupNetwork = (state) => state.getIn(['me', 'networkSignup', 'signup'], Map());

const makeSelectSignupNetworkNetwork = () =>
  createSelector(selectSignupNetwork, (state) => state.getIn(['network']));

export { makeSelectNetwork, makeSelectNetworkNetwork, makeSelectSignupNetworkNetwork };
